var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"subscription-card-help-text has-text-dark"},[(_vm.text.length > 0)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})])}
var staticRenderFns = []

export { render, staticRenderFns }